import { render, staticRenderFns } from "./FileTable.vue?vue&type=template&id=3cdce213&"
import script from "./FileTable.vue?vue&type=script&lang=js&"
export * from "./FileTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports